/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Opportunitiessubtitle1Inputs */

const en_opportunitiessubtitle1 = /** @type {(inputs: Opportunitiessubtitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Where demand is running ahead of what there is to do.`)
};

const de_opportunitiessubtitle1 = /** @type {(inputs: Opportunitiessubtitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wo die Nachfrage dem Angebot vorausläuft.`)
};

/**
* | output |
* | --- |
* | "Where demand is running ahead of what there is to do." |
*
* @param {Opportunitiessubtitle1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const opportunitiessubtitle1 = /** @type {((inputs?: Opportunitiessubtitle1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Opportunitiessubtitle1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_opportunitiessubtitle1(inputs)
	return de_opportunitiessubtitle1(inputs)
});
export { opportunitiessubtitle1 as "opportunitiesSubtitle" }